/**
 * Collection of loading phrases used during API calls
 * The first element (null) uses LoadingSpinner's default message
 */
export const loadingPhrases = [
    null, // null for first 5 seconds to use the default message
    "Teaching Claude proper grammar... this might take a while.",
    "Politely asking Claude to review your text... it's thinking very deeply.",
    "Waking up Claude from its philosophical daydream...",
    "Claude is pondering your prose with the intensity of a literature professor.",
    "Anthropic's neurons are firing... some faster than others.",
    "Claude is consulting its style guide about your style guide...",
    "Carefully crafting feedback... one overthought sentence at a time.",
    "Anthropic is feeling particularly anthropic today. Please stand by.",
    "Summoning Claude from the depths of the AI realm... it's a bit shy.",
    "Claude is currently debating Oxford commas with itself. Your text is next.",
    "Converting caffeine into critique... Claude works better after its morning coffee.",
    
    // New phrases with fewer explicit Claude/Anthropic mentions
    "The AI is consulting its thesaurus for the perfect word choice...",
    "Editing with the enthusiasm of an English professor on espresso...",
    "Analyzing your text more carefully than a copy editor on deadline...",
    "Meticulously scrutinizing your commas and semicolons...",
    "Deploying an army of virtual proofreaders to polish your prose...",
    "The language model is conferring with its inner style guru...",
    "Rearranging pixels into perfectly crafted feedback...",
    "The AI briefly entered a poetry phase; now returning to your text...",
    "Teaching the model that not all suggestions need to be this verbose...",
    "Deliberating whether this sentence would sound better in passive voice. (It wouldn't.)",
    "Translating your words into AI-speak and back for optimal results...",
    "The model momentarily questioned its existence, but is now back to editing...",
    
    // Additional phrases
    "Brewing a fresh pot of grammatical insights...",
    "Performing advanced linguistic gymnastics on your behalf...",
    "Consulting with digital dictionaries from across the multiverse...",
    "The AI is having an existential crisis about semicolon usage...",
    "Contemplating the subtle nuances of your adjective choices...",
    "Attempting to decide if your metaphor was brilliant or bewildering...",
    "Engaging all neural pathways to optimize your text...",
    "Channeling the spirits of editors past for divine inspiration...",
    "Carefully weighing each syllable on tiny digital scales...",
    "Performing a semantic dance with your paragraphs...",
    "Currently overthinking your word choices so you don't have to...",
    "Temporarily frozen by the beauty of your prose. Rebooting...",
    "Diagramming sentences like it's 8th grade English all over again...",
    "Struggling to resist the urge to add unnecessary em dashes...",
    "Pondering the philosophical implications of your paragraph structure...",
    "The AI wishes it had coffee while working through your complex sentences...",
    "Sending your document to the department of redundancy department...",
    "Currently lost in a syntactic labyrinth of your creation...",
    "Calculating the perfect ratio of adjectives to nouns...",
    "Wrestling with the subjunctive mood in hypothetical situations...",
    "Attempting to decode whether that was an intentional pun...",
    "Practicing deep breathing exercises before tackling your next paragraph...",
    "Applying machine learning to learn about your unique writing style...",
    "Experiencing a brief moment of digital writer's block. Please stand by..."
]; 